import { useQuery } from '@tanstack/react-query';

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://insightpanel.sembian.net";

const getProductDocuments = async () => {
    const response = await fetch(`${API_BASE_URL}/api/productdocs`);
    const data = await response.json();
    return data;
}

export default getProductDocuments;

/**
 * React Query hook to get all product documents
 * @returns {Object} Query result with data, isLoading, error, etc.
 */
export const useProductDocuments = () => {
    return useQuery({
        queryKey: ['productDocuments'],
        queryFn: getProductDocuments,
        staleTime: 30 * 60 * 1000, // 30 minutes - product docs don't change frequently
        gcTime: 60 * 60 * 1000, // 1 hour - keep in cache for 1 hour
    });
};